import { Store } from '.';

export type LoaderSlice = {
  skipGlobalLoader: boolean;
  setSkipGlobalLoader: (skipGlobalLoader: boolean) => void;
};

export const getLoaderInitialState =
  (set: (stateUpdater: (state: Store) => Partial<Store>) => void): LoaderSlice => ({
    skipGlobalLoader: false,
    setSkipGlobalLoader: (skipGlobalLoader: boolean) => {
      set((state: Store) => ({
        loaderSlice: {
          ...state.loaderSlice,
          skipGlobalLoader,
        },
      }));
    }
  });
